import Vue from 'vue'
import VueRouter from 'vue-router'
Vue.use(VueRouter)

const P404 = r => require.ensure([], () => r(require('../views/commons/404')))
const Login = r => require.ensure([], () => r(require('../views/commons/login')))
let Guide_StationList = r => require.ensure([], () => r(require('../views/commons/station_list')))
const routeArray = [];

if(process.env.MODULE == 'pv'){
    const Dashboard_Photovoltaic = r =>  require.ensure([], () => r(require('../views/photovoltaic/dashboard/photovoltaic')))
    routeArray.push({ path: '/photovoltaic/dashboard', component: Dashboard_Photovoltaic, hidden: true});
    Guide_StationList = r => require.ensure([], () => r(require('../views/photovoltaic/commons/station_list')))
}else if(process.env.MODULE == 'pd'){
    Guide_StationList = r => require.ensure([], () => r(require('../views/power/commons/station_list')))
}else if(process.env.MODULE == 'hy'){
    const Dashboard_Power = r =>  require.ensure([], () => r(require('../views/hydro/commons/dashboard')))
    routeArray.push({ path: '/hydro/dashboard', component: Dashboard_Power, hidden: true});
    Guide_StationList = r => require.ensure([], () => r(require('../views/hydro/commons/station_list')))
}
console.log(process.env.MODULE)

const router = new VueRouter({
    //mode: 'history',
    // base: __dirname,
    routes: [
        // {path: '/', component: Layout, children: pageRoutes},
        { path: '/login', component: Login, hidden: true },
        ...routeArray,
        { path: '/stationlist', component: Guide_StationList, hidden: true},
        { path: '*', component: P404, hidden: true }
    ]
})


export default router;


// WEBPACK FOOTER //
// ./src/router/index.js